import { render, staticRenderFns } from "./withdrawalrecord.vue?vue&type=template&id=578adb76&"
import script from "./withdrawalrecord.vue?vue&type=script&lang=js&"
export * from "./withdrawalrecord.vue?vue&type=script&lang=js&"
import style0 from "./withdrawalrecord.vue?vue&type=style&index=0&id=578adb76&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports